(function (app) {

    app.provider("inforceTransactionApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    //GETs
                    service.get = function (transactionId) {
                        return complianceHubApiGateway.get("/Transactions/" + transactionId + "/InforceTransactions");
                    };

                    //PUTs
                    service.update = function (model) {
                        return complianceHubApiGateway.put("/InforceTransactions/" + model.Id, model);
                    };

                    //POSTs
                    service.add = function (model) {
                        return complianceHubApiGateway.post("/InforceTransactions", model);
                    };

                    //DELETs
                    service.remove = function(inforceTransactionId) {
                        return complianceHubApiGateway.delete("/InforceTransactions/" + inforceTransactionId);
                    };

                    return service;
                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line